import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonGroup: {
    background: '#fff',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
  },
  formControl: {
    minWidth: 120,
    height: '40px',
  },
  select: {
    background: '#fff',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '40px',
    '& .MuiSelect-root': {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
    },
  },
  refreshButton: {
    minWidth: 48,
    height: '40px',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: 'none',
    background: '#fff',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      width: '1px',
      height: '60%',
      backgroundColor: '#e0e0e0',
    },
  },
  refreshIcon: {
    padding: '4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))
